import styled from "styled-components";
import { Type } from "discover.medical.react-component-library";

export const StyledBodyTitle = styled(Type)`
  & p {
    display: inline;
  }
`;
